import {Component, OnInit, Input, EventEmitter, Output} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {FormService} from '../../../services/formServices';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-observaciones-tecnico',
  templateUrl: './observaciones-tecnico.component.html',
  styleUrls: ['./observaciones-tecnico.component.scss']
})
export class ObservacionesTecnicoComponent implements OnInit {
    @Input('id')id: number;
    @Input('observaciones')observaciones: any;
    @Input('type')type:string;
    @Input('modal')modal: any;
    @Input('state')state: string;
    @Output('saved')saved = new EventEmitter<boolean>();
    myform: FormGroup;
    disable: boolean;
    constructor(private formService: FormService, private toastr: ToastrService) {}

  ngOnInit() {
        this.disable = false;
        this.myform = new FormGroup({
          id: new FormControl(''),
          observacion: new FormControl(''),
      });
      this.actualizarForm();

      if(this.state === 'finalizados'){
          this.myform.controls['observacion'].disable();
          this.myform.controls['categoria'].disable();
          this.myform.controls['subcategoria'].disable();
          this.myform.controls['sistema'].disable();
          this.disable = true;
      }

  }
  actualizarForm(){
      this.myform.patchValue({
              id: this.id,
              observacion: this.observaciones,
          }
      );
  }

    saveObs() {
            this.formService.updateObservacion(this.myform.value).subscribe(
                datax => {
                    this.toastr.success('Datos guardados!', 'Exito');
                    this.modal.hide();
                    this.saved.emit(true);
                },
                error => this.toastr.error('Ha ocurrido un error al guardar la observacion', 'Error')
            );
        }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/form/observaciones-tecnico/observaciones-tecnico.component.ts